module.exports = "/images/side-delete-project-active.svg?5ea387c769a080f1cee5a5a4f0e4950d";